import type { ReactNode } from 'react';
import { useState } from 'react';
import { PageLayoutContext, PageLayoutSlotContext } from './context';

type Props = {
  children: ReactNode;
};
export default function PageLayoutProvider({ children }: Props) {
  const [pageHeaderSlot, setPageHeaderSlot] = useState<ReactNode>(null);
  const [pageSidebarSlot, setPageSidebarSlot] = useState<ReactNode>(null);

  return (
    <PageLayoutContext value={{ setPageHeaderSlot, setPageSidebarSlot }}>
      <PageLayoutSlotContext value={{ pageHeaderSlot, pageSidebarSlot }}>
        {children}
      </PageLayoutSlotContext>
    </PageLayoutContext>
  );
}
